import { render } from "./financeAccordion.vue?vue&type=template&id=10f997e2&scoped=true"
import script from "./financeAccordion.vue?vue&type=script&lang=js"
export * from "./financeAccordion.vue?vue&type=script&lang=js"

import "./financeAccordion.vue?vue&type=style&index=0&id=10f997e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f997e2"]])

export default __exports__